export function setLines(state, lines){
  state.lines = lines
}
export function setOrdersProduct(state, orders_product){
  state.orders_product = orders_product
}
export function setProducts(state, products){
  state.products = products
}
export function setProductSales(state, sales){
  state.sales = sales
}
export function setContacts(state, contacts){
  state.contacts = contacts
}
export function setProviders(state, providers){
  state.providers = providers
}
export function setBoProduct(state, back_orders){
  state.back_orders = back_orders
}
export function setTransit(state, transit){
  state.transit = transit
}
export function setOrderQuantity(state, orderQuantity){
  state.orderQuantity = orderQuantity
}
export function setPdfRoute(state, pdfRoute){
  state.pdfRoute = pdfRoute
}
export function setEntriesImport(state, entries_import){
  state.entries_import = entries_import
}
export function setDetailMonths(state, detail_months){
  state.detail_months = detail_months.detail_per_months

  state.columns_detail_months = [];
  detail_months.months.forEach(month => {
    state.columns_detail_months.push({
      headerName: month.headerName,
      field     : month.field,
      width     : 200,
    })
  });
}
export function setEntraces(state, entraces){
  state.entraces = entraces
}


// WEBPACK FOOTER //
// ./src/modules/inventory-reposition/mutations.js